'use client';

import { useSyncExternalStore } from 'react';

export function useMediaQuery(query: string): boolean {
  const getSnapshot = () => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  };

  // Функция для подписки на изменения медиа-запроса
  const subscribe = (callback: () => void) => {
    if (typeof window === 'undefined') {
      return () => {
        // default no-op
      };
    }
    const mediaQueryList = window.matchMedia(query);
    const handler = () => callback();

    mediaQueryList.addEventListener('change', handler);
    return () => mediaQueryList.removeEventListener('change', handler);
  };

  // Используем useSyncExternalStore для external store subscription
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
